import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LogOut, User, ChevronDown, Settings, Bell } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const Navbar = () => {
  const { user, isLoggedIn, logout } = useAuth();
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const getInitials = (name) => {
    if (!name) return '?';
    return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  };

  return (
    <nav className="navbar">
      {/* Logo */}
      <Link to={isLoggedIn ? '/dashboard' : '/'} className="navbar-logo">
        ظبطت 🎉
      </Link>

      {/* Right Side */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        {isLoggedIn ? (
          <>
            {/* User Dropdown */}
            <div style={{ position: 'relative' }}>
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '6px 12px',
                  background: 'var(--bg-elevated)',
                  border: '1px solid var(--border-light)',
                  borderRadius: 'var(--radius-full)',
                  cursor: 'pointer',
                  color: 'var(--text-primary)',
                  transition: 'var(--transition)'
                }}
              >
                {user?.avatar ? (
                  <img
                    src={user.avatar}
                    alt={user.name}
                    className="avatar avatar-sm"
                  />
                ) : (
                  <div className="avatar avatar-sm">
                    {getInitials(user?.name)}
                  </div>
                )}
                <span style={{ fontSize: '0.85rem', fontWeight: 600 }}>
                  {user?.name?.split(' ')[0]}
                </span>
                <ChevronDown size={14} style={{ opacity: 0.6 }} />
              </button>

              {dropdownOpen && (
                <div
                  style={{
                    position: 'absolute',
                    top: 'calc(100% + 8px)',
                    left: 0,
                    background: 'var(--bg-card)',
                    border: '1px solid var(--border-light)',
                    borderRadius: 'var(--radius-lg)',
                    padding: '8px',
                    minWidth: '180px',
                    zIndex: 200,
                    boxShadow: 'var(--shadow-lg)',
                    animation: 'slideUp 0.2s ease'
                  }}
                  onMouseLeave={() => setDropdownOpen(false)}
                >
                  <DropdownItem icon={<User size={15} />} label="بروفايلي" onClick={() => { navigate('/profile'); setDropdownOpen(false); }} />
                  <DropdownItem icon={<Settings size={15} />} label="الإعدادات" onClick={() => { navigate('/profile'); setDropdownOpen(false); }} />
                  <div className="divider" style={{ margin: '6px 0' }} />
                  <DropdownItem icon={<LogOut size={15} />} label="تسجيل الخروج" onClick={handleLogout} danger />
                </div>
              )}
            </div>
          </>
        ) : (
          <>
            <Link to="/login" className="btn btn-ghost btn-sm">دخول</Link>
            <Link to="/register" className="btn btn-primary btn-sm">سجّل الآن</Link>
          </>
        )}
      </div>
    </nav>
  );
};

const DropdownItem = ({ icon, label, onClick, danger }) => (
  <button
    onClick={onClick}
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      width: '100%',
      padding: '9px 12px',
      background: 'transparent',
      border: 'none',
      borderRadius: 'var(--radius-sm)',
      color: danger ? 'var(--danger)' : 'var(--text-primary)',
      fontSize: '0.85rem',
      fontWeight: 500,
      cursor: 'pointer',
      transition: 'var(--transition)',
      textAlign: 'right',
    }}
    onMouseEnter={e => e.currentTarget.style.background = danger ? 'rgba(239,68,68,0.1)' : 'var(--bg-elevated)'}
    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
  >
    {icon}
    {label}
  </button>
);

export default Navbar;
